import moment from 'moment'

export const formatDates = (value) => {
  if (value) {
    let year = (new Date(value).getFullYear()).toString()
    let month = (new Date(value).getMonth())
    month += 1
    let date = (new Date(value).getDate()).toString()
    let concatDate = year + '' + (month < 10 ? '0' + month : month) + '' + (date.length === 1 ? ('0' + date) : date)
    let dateVal = moment(concatDate.toString(), 'YYYYMMDD').fromNow()
    if (moment(concatDate.toString(), 'YYYYMMDD').isValid()) {
      return dateVal
    } else {
      return value
    }
  } else {
    return false
  }
}

// export const todayDate = (value) => {
//   return moment().unix(value).format('YYYY-MM-DD').isSame('value', 'day');
// }

export const formatTime = (value) => {
  return moment.unix(value).format('h:mm A');
}

export const formatDate = (value) => {
  return moment.unix(value).format('DD/MM/YYYY');
}

export const dayMonth = (value) => {
  return moment.unix(value).format('DD MMM');
}
export const creditFilter = (value) => {
  if (value == null || value == '0' || value == undefined) {
    return '0.00' ;
  } else {
    return (value / 100).toFixed(2) ;
  }
}

export const friendlyPhoneName = (name, number) => {
  if (name) {
    return `+${number} - ${name}`
  }
  return `+${number}`
}
export const duration = (value, type) => {
  switch (type) {
    case 'humanize':
      return moment.duration(value).humanize();
      // break;
    default:
      break;
  }
}

export const featureFilter = (value) => {
  let filterValue = ''
  if (value === 'sms') filterValue = 'SMS'
  if (value === 'callsms') filterValue = 'CALL + SMS'
  if (value === 'call') filterValue = 'CALL'
  if (value === 'fax') filterValue = 'FAX'
  if (value === 'simwhats') filterValue = 'WhatsSIM'
  if (value === 'simtrash') filterValue = 'TrashSIM'
  return filterValue
}

export const formatExpireDate = (value) => {
  let year = (new Date(value).getFullYear()).toString()
  let month = (new Date(value).getMonth())
  month += 1
  let date = (new Date(value).getDate()).toString()
  let concatDate = year + '' + (month < 10 ? '0' + month : month) + '' + (date.length === 1 ? ('0' + date) : date)
  let dateVal = moment(concatDate.toString(), 'YYYYMMDD').fromNow()
  if (moment(concatDate.toString(), 'YYYYMMDD').isValid()) {
    return dateVal
  } else {
    return 'at ' + value
  }
}
